import React from 'react';
import './Stats.css';

const Stats = () => {
  const stats = [
    { number: '10+', label: 'Years of Excellence' },
    { number: '1000+', label: 'Students Guided' },
    { number: '4', label: 'Branches' },
    { number: '5', label: 'Syllabi Covered' }
  ];

  return (
    <section>
      <div className="stats-section">
        <h2 className="section-title" style={{ color: 'var(--white)' }}>
          Our Journey of Excellence
        </h2>
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
